module.exports = __webpack_public_path__ + "3fac4b659d4f5ddb9fef3ff76604113e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/event-airlift.png
 ** module id = 1059
 ** module chunks = 0
 **/